var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlovenia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0225C24.8366 32.0225 32 24.859 32 16.0225C32 7.1859 24.8366 0.0224609 16 0.0224609C7.16344 0.0224609 0 7.1859 0 16.0225C0 24.859 7.16344 32.0225 16 32.0225Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0048 10.4574H13.9131V6.28351H5.56519V10.4574H0.995188C0.352063 12.1907 0 14.0655 0 16.0226C0 17.9798 0.352063 19.8545 0.995188 21.5878L16 22.9791L31.0048 21.5878C31.6479 19.8545 32 17.9798 32 16.0226C32 14.0655 31.6479 12.1907 31.0048 10.4574Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 32.0225C22.8796 32.0225 28.7443 27.6805 31.005 21.5877H0.995361C3.25605 27.6805 9.12074 32.0225 16.0002 32.0225Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.56519 10.4571V11.8484C5.56519 15.0434 9.73912 16.0224 9.73912 16.0224C9.73912 16.0224 13.9131 15.0434 13.9131 11.8484V10.4571L12.5217 11.8484L9.73912 9.76151L6.9565 11.8484L5.56519 10.4571Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0224609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlovenia);
export default __webpack_public_path__ + "static/media/slovenia.5ae6c830.svg";
export { ForwardRef as ReactComponent };